import { render } from "./TechnologyResearchInstitutePage.vue?vue&type=template&id=4676eb84"
import script from "./TechnologyResearchInstitutePage.vue?vue&type=script&lang=js"
export * from "./TechnologyResearchInstitutePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__